import axios from 'axios';
import { Dispatch } from 'react';

import { AnyIfEmpty } from 'react-redux';
import {
    CLEAR_KEY_PICKUP_DROP_EVENTS_STATE,
    GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_FAILURE,
    GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_REQUEST,
    GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_SUCCESS,
} from '../constants/keyPickupDropEvents.constant';

// Interface for vendor appointment data
export interface PropertyEvents {
    id: string;
    accessCode: string;
    appointmentId: string;
    vendorName: string;
    vendorEmail: string;
    vendorPhone: string;
    appointmentDate: string;
    startTime: string;
    endTime: string;
    status: 'scheduled' | 'in-progress' | 'completed' | 'cancelled';
    locationId: string;
    locationName: string;
    unitNumber?: string;
    specialInstructions?: string;
    createdAt: string;
    updatedAt: string;
}

// Interface for API response
export interface PropertyEventsResponse {
    statusCode: number;
    message: string;
    appointments: PropertyEvents[];
    totalCount: number;
}

// Interface for access code request parameters
export interface GetPropertyEventsByAccessCodeParams {
    accessCode: string;
    locationId: string;
}

// Action creators
const getKeyPickupDropEventsByAccessCodeRequest = () => {
    return {
        type: GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_REQUEST,
    };
};

const getKeyPickupDropEventsByAccessCodeSuccess = (appointments: PropertyEvents[]) => {
    return {
        type: GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_SUCCESS,
        payload: appointments,
    };
};

const getKeyPickupDropEventsByAccessCodeFailure = (error: string) => {
    return {
        type: GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_FAILURE,
        payload: error,
    };
};

const clearKeyPickupDropEventsStateAction = () => {
    return {
        type: CLEAR_KEY_PICKUP_DROP_EVENTS_STATE,
    };
};

// Main action to fetch vendor appointments by access code
export const getKeyPickupDropEventsByAccessCode = (params: GetPropertyEventsByAccessCodeParams) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getKeyPickupDropEventsByAccessCodeRequest());

        axios
            .get(`/property-events-visit/find-by-location-access/${params.locationId}/${params.accessCode}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    // Handle successful response
                    const token = response?.data?.event?.accessToken;
                    if (typeof window !== 'undefined' && token && response?.data?.event?.id) {
                        localStorage.setItem('keyPickupDropEventAccess', token);
                    }
                    const events = response?.data?.event;
                    dispatch(getKeyPickupDropEventsByAccessCodeSuccess(events));
                } else {
                    console.error('Error fetching property events:', response?.data?.message);
                    dispatch(getKeyPickupDropEventsByAccessCodeFailure(response?.data?.message || 'Failed to fetch property events'));
                }
            })
            .catch((error) => {
                // Handle network or other errors
                const errorMessage = error?.response?.data?.message || error?.message || 'Network error occurred';
                dispatch(getKeyPickupDropEventsByAccessCodeFailure(errorMessage));
            });
    };
};

// Action to clear vendor appointments state
export const clearKeyPickupDropEventsState = () => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(clearKeyPickupDropEventsStateAction());
    };
};
